import { CloseOutlined } from "@ant-design/icons";
import { ActionIcon, Tooltip } from "@mantine/core";
import React from "react";
import { MdModeEditOutline } from "react-icons/md";
import FormikAwareTextInput from "../../forms/formik/FormikAwareTextInput";
import { Form, Formik } from "formik";
import * as yup from "yup";

const SCHEMA = yup.object({
  text: yup.string().max(1000, "Max character limit is 1000.").optional(),
});

const TextInlineEdit = ({
  text,
  isTooltip = false,
  isEditable = false,
  onChange = () => {},
  className = "",
}: {
  text: string;
  isTooltip?: boolean;
  isEditable?: boolean;
  onChange?: (text: string) => void;
  className?: string;
}) => {
  const [editMode, setEditMode] = React.useState<boolean>(false);
  return (
    <div className={`w-220 ${className}`}>
      {text && (
        <>
          {editMode ? (
            <Formik
              validationSchema={SCHEMA}
              onSubmit={(value: { text: string }) => {
                onChange(value.text ?? "");
                setEditMode(false);
              }}
              initialValues={{ text: text }}
              enableReinitialize
            >
              <Form className="row row-column gap-16 ">
                <div className={`form__row input-right-icon `}>
                  <FormikAwareTextInput
                    id="inlineText"
                    name="text"
                    type="text"
                    defaultValue={text}
                    onBlur={() => setEditMode(false)}
                    rightSection={
                      <ActionIcon onClick={() => setEditMode(false)}>
                        <CloseOutlined />
                      </ActionIcon>
                    }
                  />
                </div>
              </Form>
            </Formik>
          ) : (
            <div className={`row row-v-center row-space-between gap-4 `}>
              {isTooltip ? (
                <Tooltip
                  label={
                    <div className="white-space-pre-wrap word-break-break-all w-220 p-8">
                      {text}
                    </div>
                  }
                >
                  <div
                    className={
                      "white-space-no-wrap text-overflow-ellipsis overflow-hidden"
                    }
                  >
                    {text}
                  </div>
                </Tooltip>
              ) : (
                <div
                  className={
                    "white-space-no-wrap text-overflow-ellipsis overflow-hidden"
                  }
                >
                  {text}
                </div>
              )}
              {isEditable && (
                <ActionIcon
                  onClick={() => {
                    setEditMode(true);
                  }}
                >
                  <MdModeEditOutline size="1.125rem" />
                </ActionIcon>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TextInlineEdit;
